import { c as _c } from "react/compiler-runtime";
import { BodyLong, BodyShort, GuidePanel } from "@navikt/ds-react";
import { UiSelector } from "@/utils/uiSelectors";
export default function InfoPanel() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GuidePanel poster={true} data-testid={UiSelector.RegistreringInfoPanel}><BodyLong spacing={true}>Her kan du oppgi hvem som er nærmeste leder for en sykmeldt ansatt. Dette er for å sikre at riktig leder skal få tilgang til oppfølgingstjenestene på "Dine sykmeldte" for å følge opp den ansatte som er syk.</BodyLong><BodyShort>Den ansatte må være sykmeldt for at det skal være mulig å oppgi inn hvem som er nærmeste leder.</BodyShort></GuidePanel>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}